import { createFileRoute } from '@tanstack/react-router'
import ResourceDetailPage from '@/pages/resources/detail'

export const Route = createFileRoute('/app/resources/$resourceId')({
  component: RouteComponent,
})

function RouteComponent() {
  const { resourceId } = Route.useParams()
  return <ResourceDetailPage id={Number(resourceId)} />
}
